/* eslint-disable no-unused-expressions */
import { newReconServiceAPI } from "./APIutils";
import { NEW_BASE_URL } from "../Constant";

export function fetchPendingAllSettlements({
  pageNo,
  pageSize = 10,
  cityFilter = [],
  operatorFilter = [],
  sortBy = {},
}) {
  const url = `${NEW_BASE_URL}/v1/settlementsPage/netDueFromDailySummary`;
  return newReconServiceAPI(url, {
    pageNo,
    pageSize,
    sort: sortBy || {},
    addOnFilter: {
      cityIdArr: cityFilter,
      operatorIdArr: operatorFilter,
      settled: { exists: true },
    },
  });
}

export function fetchSettledSettlements({
  pageNo,
  pageSize = 10,
  cityFilter = [],
  operatorFilter = [],
  sortBy = {},
}) {
  const url = `${NEW_BASE_URL}/v1/settlementsPage/netDueFromDailySummary`;
  return newReconServiceAPI(url, {
    pageNo,
    pageSize,
    sort: sortBy || {},
    addOnFilter: {
      cityIdArr: cityFilter,
      operatorIdArr: operatorFilter,
      settled: "yes",
    },
  });
}

export function fetchPreviousSettlements({
  pageNo,
  pageSize = 10,
  operatorFilter = [],
  cityFilter = [],
  extraParams = {},
}) {
  const url = `${NEW_BASE_URL}/v1/settlementsPage/previousSettlements`;
  return newReconServiceAPI(url, {
    pageNo,
    pageSize,
    sort: extraParams.sortBy || {},
    addOnFilter: {
      cityIdArr: cityFilter,
      operatorIdArr: operatorFilter,
    },
  });
}

export function fetchSettlementSummary({
  pageNo,
  pageSize = 10,
  cityFilter = [],
  sortBy = {},
  operatorFilter = [],
  dateFilter = null,
}) {
  // eslint-disable-next-line no-param-reassign
  operatorFilter = operatorFilter && operatorFilter.toString();
  const cityIdArr = [];
  cityFilter && cityIdArr.push(cityFilter);
  const operatorIdArr = [];
  operatorFilter && operatorIdArr.push(operatorFilter);
  const url = `${NEW_BASE_URL}/v1/settlementsPage/operatorCurrentNetDue`;
  return newReconServiceAPI(url, {
    pageNo,
    pageSize,
    sort: sortBy || {},
    addOnFilter: {
      cityIdArr,
      operatorIdArr,
      date: dateFilter,
    },
  });
}

export function fetchSettlementLedger({
  pageNo,
  pageSize = 10,
  sort,
  cityId,
  operatorId,
}) {
  const url = `${NEW_BASE_URL}/v1/settlementsPage/operatorLedger`;
  const payload = {
    pageNo,
    pageSize,
    sort,
    addOnFilter: {
      cityId,
      operatorId,
    },
  };
  return newReconServiceAPI(url, payload);
}

export function settleAmount(settlementDetails) {
  const url = `${NEW_BASE_URL}/v1/settlementsPage/settleOperator`;
  return newReconServiceAPI(url, {
    ...settlementDetails,
    timezoneOffset: 330,
  });
}

export function editSettleAmount(settlementDetails) {
  const url = `${NEW_BASE_URL}/v1/settlementsPage/editOperatorPayment`;
  return newReconServiceAPI(url, {
    ...settlementDetails,
    timezoneOffset: 330,
  });
}

export function settlementUploadSheets(data) {
  const url = `${NEW_BASE_URL}/v1/settlementsPage/uploadOperatorSettlementSheet`;
  return newReconServiceAPI(url, {
    ...data,
  });
}

// Api call to get bulk settlement upload status
export function getBulkSettlementProcessStatusService(filter = {}) {
  const url = `${NEW_BASE_URL}/v1/settlementsPage/bulkSettlementProcessStatus`;
  return newReconServiceAPI(url, {
    addOnFilter: filter,
  });
}
